export default __webpack_public_path__ + "static/media/61-min.2bf04733.jpg";